<ion-header>
  <ion-toolbar>
    <ion-title>{{ (editMode ? 'PLAYLISTS.MODAL_EDIT_TITLE' : 'PLAYLISTS.MODAL_NEW_TITLE') | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">{{ 'PLAYLISTS.MODAL_CANCEL' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-list>
    <ion-item>
      <ion-input [label]="'PLAYLISTS.MODAL_NAME_LABEL' | translate" label-placement="stacked" [(ngModel)]="name" type="text" [placeholder]="'PLAYLISTS.MODAL_NAME_PLACEHOLDER' | translate" maxlength="100"></ion-input>
    </ion-item>
    <div *ngIf="nameError" class="error-message">{{ 'PLAYLISTS.MODAL_NAME_ERROR' | translate }}</div>

    <ion-item>
      <ion-textarea [label]="'PLAYLISTS.MODAL_DESC_LABEL' | translate" label-placement="stacked" [(ngModel)]="description" rows="3" [placeholder]="'PLAYLISTS.MODAL_DESC_PLACEHOLDER' | translate" maxlength="500"></ion-textarea>
    </ion-item>

    <!-- YouTube import — create mode only -->
    <ng-container *ngIf="!editMode">
      <ion-item>
        <ion-input
          [label]="'PLAYLISTS.MODAL_IMPORT_LABEL' | translate"
          label-placement="stacked"
          [(ngModel)]="youtubePlaylistUrl"
          (ionInput)="onYoutubeUrlChange()"
          type="url"
          [placeholder]="'PLAYLISTS.MODAL_IMPORT_PLACEHOLDER' | translate"
          inputmode="url"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none">
          <ion-icon name="logo-youtube" slot="end" color="danger"></ion-icon>
        </ion-input>
      </ion-item>
      <div *ngIf="youtubeUrlError" class="error-message">{{ 'PLAYLISTS.MODAL_IMPORT_ERROR' | translate }}</div>
      <p *ngIf="!youtubeImportConfigured" class="import-hint warning">{{ 'PLAYLISTS.IMPORT_NOT_CONFIGURED' | translate }}</p>
      <p *ngIf="youtubeImportConfigured && !youtubeUrlError && !youtubePlaylistUrl" class="import-hint">{{ 'PLAYLISTS.MODAL_IMPORT_HINT' | translate }}</p>
    </ng-container>
  </ion-list>

  <div class="permissions-row">
    <ion-item class="perm-item" lines="none">
      <ion-select [label]="'PLAYLISTS.MODAL_VISIBILITY' | translate" label-placement="stacked" [(ngModel)]="visibility" interface="action-sheet">
        <ion-select-option value="public">{{ 'PLAYLISTS.MODAL_PUBLIC' | translate }}</ion-select-option>
        <ion-select-option value="link">{{ 'PLAYLISTS.MODAL_WITH_LINK' | translate }}</ion-select-option>
        <ion-select-option value="private">{{ 'PLAYLISTS.MODAL_PRIVATE' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item class="perm-item" lines="none" [disabled]="isPrivate">
      <ion-select [label]="'PLAYLISTS.MODAL_OTHERS_CAN' | translate" label-placement="stacked" [(ngModel)]="collaboration" interface="action-sheet" [disabled]="isPrivate">
        <ion-select-option value="viewer">{{ 'PLAYLISTS.MODAL_VIEW_ONLY' | translate }}</ion-select-option>
        <ion-select-option value="commenter">{{ 'PLAYLISTS.MODAL_COMMENT' | translate }}</ion-select-option>
        <ion-select-option value="editor">{{ 'PLAYLISTS.MODAL_ADD_SONGS' | translate }}</ion-select-option>
        <ion-select-option value="full_editor">{{ 'PLAYLISTS.MODAL_ADD_REMOVE' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>
  </div>

  <!-- Import progress -->
  <div *ngIf="importStatus" class="import-status">
    <ion-spinner name="crescent" class="import-spinner"></ion-spinner>
    <span>{{ importStatus }}</span>
  </div>

  <div class="submit-container">
    <ion-button expand="block" (click)="submit()" [disabled]="submitting">
      <ion-spinner *ngIf="submitting" name="crescent"></ion-spinner>
      <span *ngIf="!submitting">{{ (editMode ? 'PLAYLISTS.MODAL_UPDATE' : 'PLAYLISTS.MODAL_CREATE') | translate }}</span>
    </ion-button>
    <ion-button *ngIf="editMode" expand="block" color="danger" fill="outline" (click)="confirmDelete()" [disabled]="submitting">
      {{ 'PLAYLISTS.MODAL_DELETE' | translate }}
    </ion-button>
  </div>
</ion-content>
